const rooster = {
  container: {
    position: 'absolute',
    right: '54px',
    bottom: '-11px',
    height: '20px',
    width: '20px',
  },
  container_delivered: {
    position: 'absolute',
    right: '61px',
    bottom: '-11px',
    height: '20px',
    width: '20px',
  },
  container_failure: {
    position: 'absolute',
    right: '54px',
    bottom: '10px',
    height: '20px',
    width: '20px',
  },
  failure: {
    height: '18px',
    width: '18px',
    fill: 'white',
    backgroundColor: 'red',
    borderRadius: '10px',
    border: '1px solid white',
  },
  sent: {
    height: '18px',
    width: '18px',
    fill: 'white',
    backgroundColor: '#ccc',
    borderRadius: '10px',
    border: '1px solid white',
  },
  delivered: {
    height: '18px',
    width: '18px',
    fill: 'white',
    backgroundColor: 'rgb(103, 58, 183)',
    borderRadius: '10px',
    border: '1px solid white',
  },
  delivered_2: {
    height: '18px',
    width: '18px',
    fill: 'white',
    backgroundColor: 'rgb(103, 58, 183)',
    borderRadius: '10px',
    border: '1px solid white',
    position: 'absolute',
    left: '9px',
    bottom: '2px',
  },
  errorDescription: {
    position: "relative",
    color: "red",
    maxWidth: "250px",
    marginLeft: "auto",
    bottom: "-1px",
    right: "74px",
    textAlign: "right",
    fontSize: "12px",
    fontStyle: "italic",
    zIndex: "1",
  },
}

const tops = {
  container: {
    position: 'absolute',
    right: '54px',
    bottom: '-11px',
    height: '20px',
    width: '20px',
  },
  container_delivered: {
    position: 'absolute',
    right: '61px',
    bottom: '-11px',
    height: '20px',
    width: '20px',
  },
  container_failure: {
    position: 'absolute',
    right: '54px',
    bottom: '10px',
    height: '20px',
    width: '20px',
  },
  failure: {
    height: '18px',
    width: '18px',
    fill: 'white',
    backgroundColor: 'red',
    borderRadius: '10px',
    border: '1px solid white',
  },
  sent: {
    height: '18px',
    width: '18px',
    fill: 'white',
    backgroundColor: '#ccc',
    borderRadius: '10px',
    border: '1px solid white',
  },
  delivered: {
    height: '18px',
    width: '18px',
    fill: 'white',
    backgroundColor: '#0091EA',
    borderRadius: '10px',
    border: '1px solid white',
  },
  delivered_2: {
    height: '18px',
    width: '18px',
    fill: 'white',
    backgroundColor: '#0091EA',
    borderRadius: '10px',
    border: '1px solid white',
    position: 'absolute',
    left: '9px',
    bottom: '2px',
  },
  errorDescription: {
    position: 'relative',
    color: 'red',
    maxWidth: '250px',
    marginLeft: 'auto',
    bottom: '-1px',
    right: '74px',
    textAlign: 'right',
    fontSize: '12px',
    fontStyle: 'italic',
    zIndex: '1',
  },
}

module.exports = process.env.REACT_APP_IS_TOPS ?
  tops :
  rooster



// WEBPACK FOOTER //
// ./src/components/Messages/styles/TextStatusIndicator.js